import { NgModule } from '@angular/core';
import { DirectivesModule } from '../../../../directives/directives.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { DataTableModule } from '../../../data-table/data-table.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { AppDetailsComponent } from './app-details.component';
import { AppViewabilityComponent } from './app-viewability/app-viewability.component';
import { AppUserOverlapComponent } from './app-user-overlap/app-user-overlap';
import { AppTrafficOverview } from './app-traffic-overview/app-traffic-overview';
import { AppSov } from './app-sov/app-sov';
import { AppPublisherOverview } from './app-publisher-overview/app-publisher-overview';
import { AppOverviewRisk } from './app-overview-risk/app-overview-risk';
import { AppMoreDetails } from './app-more-details/app-more-details';
import { AppIvt } from './app-ivt/app-ivt';
import { AppInventory } from './app-inventory/app-inventory';
import { AppInteractiveElements } from './app-interactive-elements/app-interactive-elements';
import { AppInformationComponent } from './app-information/app-information';
import { AppDangerousPermissions } from './app-dangerous-permissions/app-dangerous-permissions';
import { AppCtr } from './app-ctr/app-ctr';
import { AppBrandSafetyRisk } from './app-brandsafety-risk/app-brandsafety-risk';
import { AppAdvisories } from './app-advisories/app-advisories';
import { AppAdvertisingSpecs } from './app-advertising-specs/app-advertising-specs';
import { routing } from './app-details.routing';
import { AppAdSpendComponent } from './app-ad-spend/app-ad-spend.component';
import { AppCoppaPermissions } from './app-coppa-permissions/app-coppa-permissions';
import { SuggestFeedbackModule } from '../../../suggest-feedback/suggest-feedback.module';
import { SharedModule } from '../../../shared/shared.module';
import { DetailsPageModule } from '../details-page/details-page.module';
import { AppDeveloperAppsComponent } from './app-developer-apps/app-developer-apps.component';
import { AppOverviewSectionComponent } from './sections/app-overview-section/app-overview-section.component';
import { AppRiskOverviewSectionComponent } from './sections/app-risk-overview-section/app-risk-overview-section.component';
import { AppDetailsSectionComponent } from './sections/app-details-section/app-details-section.component';
import { AppDeveloperOverviewSectionComponent } from './sections/app-developer-overview-section/app-developer-overview-section.component';
import { AppRankingsSectionComponent } from './sections/app-rankings-section/app-rankings-section.component';
import { AppPermissionRiskSectionComponent } from './sections/app-permission-risk-section/app-permission-risk-section.component';
import { AppCoppaViolationRiskSectionComponent } from './sections/app-coppa-violation-risk-section/app-coppa-violation-risk-section.component';
import { AppBrandSafetyRiskSectionComponent } from './sections/app-brand-safety-risk-section/app-brand-safety-risk-section.component';
import { AppTrafficTrendsSectionComponent } from './sections/app-traffic-trends-section/app-traffic-trends-section.component';
import { AppAuthorizedSellerSectionComponent } from './sections/app-authorized-seller-section/app-authorized-seller-section.component';
import { AppIvtSectionComponent } from './sections/app-ivt-section/app-ivt-section.component';
import { AppViewabilitySectionComponent } from './sections/app-viewability-section/app-viewability-section.component';
import { AppAdSpendSectionComponent } from './sections/app-ad-spend-section/app-ad-spend-section.component';
import { AppInventorySectionComponent } from './sections/app-inventory-section/app-inventory-section.component';
import { AppCtrSectionComponent } from './sections/app-ctr-section/app-ctr-section.component';
import { AppDeveloperAppsSectionComponent } from './sections/app-developer-apps-section/app-developer-apps-section.component';
import { SwiperModule } from 'swiper/angular';
import { ChartsModule } from '../../charts/charts.module';
import { InsightBadgesModule } from '../../../shared/insight-badges/insight-badges.module';
import { AppMfaSectionComponent } from './sections/app-mfa-section/app-mfa-section.component';
import { AppMfa } from './app-mfa/app-mfa';
import { AppSdkDetailsSectionComponent } from './sections/app-sdk-details-section/app-sdk-details-section.component';
import { AppSdkDetailsComponent } from './app-sdk-details/app-sdk-details.component';
import { AppEngagementMetricsSectionComponent } from './sections/app-engagement-metrics-section/app-engagement-metrics-section.component';
import { AppUserEngagement } from './app-user-engagement/app-user-engagement';
import { AppContributionPlatform } from './app-contribution-platform/app-contribution-platform';
import { AppAdPerformance } from './app-ad-performance/app-ad-performance';

@NgModule({
  declarations: [
    AppEngagementMetricsSectionComponent,

    AppDetailsComponent,
    AppViewabilityComponent,
    AppUserOverlapComponent,
    AppTrafficOverview,
    AppSov,
    AppPublisherOverview,
    AppOverviewRisk,
    AppMoreDetails,
    AppIvt,
    AppInventory,
    AppInteractiveElements,
    AppInformationComponent,
    AppDangerousPermissions,
    AppCoppaPermissions,
    AppCtr,
    AppBrandSafetyRisk,
    AppAdvisories,
    AppAdvertisingSpecs,
    AppAdSpendComponent,
    AppDeveloperAppsComponent,
    AppSdkDetailsComponent,
    AppOverviewSectionComponent,
    AppRiskOverviewSectionComponent,
    AppDetailsSectionComponent,
    AppDeveloperOverviewSectionComponent,
    AppRankingsSectionComponent,
    AppPermissionRiskSectionComponent,
    AppCoppaViolationRiskSectionComponent,
    AppBrandSafetyRiskSectionComponent,
    AppTrafficTrendsSectionComponent,
    AppAuthorizedSellerSectionComponent,
    AppIvtSectionComponent,
    AppViewabilitySectionComponent,
    AppAdSpendSectionComponent,
    AppInventorySectionComponent,
    AppCtrSectionComponent,
    AppDeveloperAppsSectionComponent,
    AppSdkDetailsSectionComponent,
    AppMfa,
    AppMfaSectionComponent,
    AppUserEngagement,
    AppContributionPlatform,
    AppAdPerformance
  ],
  imports: [
    DetailsPageModule,
    DirectivesModule,
    TooltipModule,
    DataTableModule,
    PipesModule,
    CommonModule,
    routing,
    SharedModule,
    SuggestFeedbackModule,
    SwiperModule,
    ChartsModule,
    InsightBadgesModule
  ],
  exports: [],
  providers: []
})
export class AppDetailsModule {}
